import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'content'
})`
  justify-content: space-between;
`;

export const OutlinedInputContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 48px 0;
`
